var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 18.0691V7.07643H1.54867V18.0691H5.1996H5.19922ZM3.37471 5.57582C4.64746 5.57582 5.43984 4.73172 5.43984 3.67682C5.41601 2.59789 4.64746 1.77734 3.39891 1.77734C2.1495 1.77734 1.3335 2.59789 1.3335 3.67673C1.3335 4.73162 2.12558 5.57573 3.35079 5.57573H3.37442L3.37471 5.57582ZM7.21984 18.0691H10.8701V11.9309C10.8701 11.6028 10.8939 11.2739 10.9904 11.0395C11.2541 10.3828 11.8548 9.70308 12.8635 9.70308C14.1841 9.70308 14.7127 10.711 14.7127 12.189V18.0691H18.3628V11.7662C18.3628 8.3899 16.5621 6.81871 14.1604 6.81871C12.1914 6.81871 11.3266 7.92025 10.8461 8.6705H10.8704V7.07681H7.22003C7.26768 8.10805 7.21975 18.0695 7.21975 18.0695L7.21984 18.0691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.415b9971e322fa8629350dab2499ad95.svg";
export { ForwardRef as ReactComponent };